import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button, CircularProgress } from '@mui/material';
import { AppDataTable, AppToast } from '@shared';

import axios from 'utils/axios-rails';

const propTypes = {
  webhooks: PropTypes.array.isRequired,
  submitURL: PropTypes.string.isRequired,

  topicAttributeName: PropTypes.string,
  endpointAttributeName: PropTypes.string,
};

const defaultProps = {
  topicAttributeName: "topic" // shopify default is topic
}

const Webhooks = (props) => {

  // Convert objects into array to use it on datatable
  const convertToRows = (webhooks) => {
    return webhooks.map( (wb) => 
      [ 
        wb[props.topicAttributeName], 
        wb.createdAt || "-", 
        wb.updatedAt || "-",
        wb[props.endpointAttributeName],
      ]
    );
  }

  const [ state, setState ] = useState({
    webhooksRows: convertToRows(props.webhooks),
    loading: false,
    message: ""
  });
  

  // Send request to load hooks or reload on some case(delete and load new ones).
  const reloadWebhooks = async (deleteWebhook = false) => {
    await setState({
      ...state,
      loading: true
    })
    try {
      const params = deleteWebhook ? { clear: "DO IT" } : {};
      const response = await axios.post(props.submitURL, params );
      console.log(response);
      await setState({
        ...state,
        loading: false,
        message: response.data.message
      })
    } catch (error) {
      await setState({
        ...state,
        loading: false,
        message: I18n.t("messages.request_error")
      })
    }
  }

  const dismissMessage = () => {
    setState({
      ...state,
      message: "",
    })
  }

  return(
    <div>
      <AppDataTable
        rows={ state.webhooksRows }
        headings={[
          I18n.t("settings.webhook.topic"),
          I18n.t("activerecord.attributes.general.created_at"),
          I18n.t("activerecord.attributes.general.updated_at"),
          I18n.t("settings.webhook.endpoint"),
        ]}
        columnContentTypes={[ 'text', 'text', 'text' ]}
        footerContent={
          <div>
            <Button
              variant="contained"
              fullWidth
              disabled={ state.loading }
              startIcon={ state.loading ? <CircularProgress size={16} color="inherit" /> : null }
              onClick={ reloadWebhooks }
            >
              Actualizar Webhooks
            </Button>
            <Button
              variant="contained"
              color="error"
              fullWidth
              disabled={ state.loading }
              startIcon={ state.loading ? <CircularProgress size={16} color="inherit" /> : null }
              onClick={ () => reloadWebhooks(true) }
            >
              Eliminar Webhooks
            </Button>
          </div>
        }
      />

      { !!state.message &&
        <AppToast
          content={ state.message }
          onDismiss={ dismissMessage }
        />
      }
    </div>
  )
}

Webhooks.propTypes = propTypes;
Webhooks.defaultProps = defaultProps;

export default Webhooks;